import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Coordinate from '../geom/Coordinate';
import Double from '../../../../java/lang/Double';
var Intersection = /*#__PURE__*/function () {
  function Intersection() {
    _classCallCheck(this, Intersection);
  }
  _createClass(Intersection, null, [{
    key: "intersection",
    value: function intersection(p1, p2, q1, q2) {
      var minX0 = p1.x < p2.x ? p1.x : p2.x;
      var minY0 = p1.y < p2.y ? p1.y : p2.y;
      var maxX0 = p1.x > p2.x ? p1.x : p2.x;
      var maxY0 = p1.y > p2.y ? p1.y : p2.y;
      var minX1 = q1.x < q2.x ? q1.x : q2.x;
      var minY1 = q1.y < q2.y ? q1.y : q2.y;
      var maxX1 = q1.x > q2.x ? q1.x : q2.x;
      var maxY1 = q1.y > q2.y ? q1.y : q2.y;
      var intMinX = minX0 > minX1 ? minX0 : minX1;
      var intMaxX = maxX0 < maxX1 ? maxX0 : maxX1;
      var intMinY = minY0 > minY1 ? minY0 : minY1;
      var intMaxY = maxY0 < maxY1 ? maxY0 : maxY1;
      var midx = (intMinX + intMaxX) / 2.0;
      var midy = (intMinY + intMaxY) / 2.0;
      var p1x = p1.x - midx;
      var p1y = p1.y - midy;
      var p2x = p2.x - midx;
      var p2y = p2.y - midy;
      var q1x = q1.x - midx;
      var q1y = q1.y - midy;
      var q2x = q2.x - midx;
      var q2y = q2.y - midy;
      var px = p1y - p2y;
      var py = p2x - p1x;
      var pw = p1x * p2y - p2x * p1y;
      var qx = q1y - q2y;
      var qy = q2x - q1x;
      var qw = q1x * q2y - q2x * q1y;
      var x = py * qw - qy * pw;
      var y = qx * pw - px * qw;
      var w = px * qy - qx * py;
      var xInt = x / w;
      var yInt = y / w;
      if (Double.isNaN(xInt) || Double.isInfinite(xInt) || Double.isNaN(yInt) || Double.isInfinite(yInt)) return null;
      return new Coordinate(xInt + midx, yInt + midy);
    }
  }]);
  return Intersection;
}();
export { Intersection as default };